import { useTranslation } from 'react-i18next';

import PlanCardSubHeader from '../../PlanCardComponents/PlanCardSubHeader';

import CompleteStatus from './CompleteStatus';

import { AssignableCourseResult } from '@/_generated/api-clients/xp';

interface CompletedCountProps {
  complianceStatus: AssignableCourseResult | undefined;
  totalTeamMembers: number;
  completedUsers: number;
  allUsersCompleted: boolean;
  enabled: boolean;
}

const CompletedCount: React.FC<CompletedCountProps> = ({
  allUsersCompleted,
  complianceStatus,
  totalTeamMembers,
  completedUsers,
  enabled,
}) => {
  const { t } = useTranslation();

  if (!enabled) {
    return null;
  }

  return allUsersCompleted ? (
    <PlanCardSubHeader className="success" data-testid="PlanTaskCount">
      {t('Generic.completedByAll')}
    </PlanCardSubHeader>
  ) : (
    <PlanCardSubHeader data-testid="PlanTaskCount">
      <CompleteStatus
        complianceStatus={complianceStatus}
        totalTeamMembers={totalTeamMembers}
        completedUsers={completedUsers}
        isEnabled={enabled}
      />
    </PlanCardSubHeader>
  );
};

export default CompletedCount;
